
export default {
  props: {
    color: {
      type: String,
      required: false,
      default: '#fff',
    },
  },
  mounted() {
    // const gsap = this.$gsap
    // // gsap.from(this.$refs.waypoint, 1.5, {
    // //   alpha: 0,
    // //   scaleX: 1.6,
    // //   scaleY: 1.6,
    // //   ease: 'Power3.easeInOut',
    // // })
  },
  methods: {
    animateIn() {
      this.$refs.content.classList.toggle('hidden')
      this.$refs.wrapper.classList.toggle('z-50')
      const gsap = this.$gsap

      gsap.from(this.$refs.content, 0.25, {
        scaleX: 0,
        alpha: 0,
        transformOrigin: 'left center',
        ease: 'Power4.easeOut',
      })
    },
    animateOut() {
      this.$refs.content.classList.toggle('hidden')
      this.$refs.wrapper.classList.toggle('z-50')
    },
  },
}
